// import React, { useState, useEffect, useRef } from 'react';
// import {
//   Box,
//   Container,
//   Typography,
//   Card,
//   CardContent,
//   Grid,
//   Stack,
//   alpha,
//   Chip
// } from '@mui/material';
// import {
//   AutoAwesome as AIIcon,
//   Speed as SpeedIcon,
//   Security as SecurityIcon,
//   Analytics as AnalyticsIcon,
//   Cloud as CloudIcon,
//   Support as SupportIcon,
//   CheckCircle as CheckIcon
// } from '@mui/icons-material';

// const ModernFeatures = () => {
//   const [hoveredCard, setHoveredCard] = useState(null);
//   const [isInView, setIsInView] = useState(false);
//   const sectionRef = useRef(null);

//   const features = [
//     {
//       icon: <AIIcon sx={{ fontSize: 50 }} />,
//       title: "Yapay Zeka Destekli",
//       subtitle: "Akıllı İçerik Asistanı",
//       description: "Otomatik başlık önerileri, SEO iyileştirmeleri ve trend analizi. Yapay zeka hangi konuların popüler olduğunu söyler.",
//       color: "#3b82f6",
//       gradient: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
//       features: ["Akıllı Başlık Önerileri", "SEO İyileştirme", "Trend Analizi", "Otomatik Etiketleme"]
//     },
//     {
//       icon: <SpeedIcon sx={{ fontSize: 50 }} />,
//       title: "Işık Hızında",
//       subtitle: "Okuyucular Beklemez",
//       description: "1 saniyenin altında sayfa yükleme. Otomatik görsel optimizasyonu ve temiz kod yapısı.",
//       color: "#10b981",
//       gradient: "linear-gradient(135deg, #10b981 0%, #047857 100%)",
//       features: ["1 Saniyede Açılış", "Otomatik Görsel Sıkıştırma", "Gereksiz Kod Yok", "Hızlı Sunucu"]
//     },
//     {
//       icon: <SecurityIcon sx={{ fontSize: 50 }} />,
//       title: "Kurumsal Güvenlik",
//       subtitle: "Verileriniz Güvende",
//       description: "Banka seviyesinde güvenlik. Şifreli bağlantı, otomatik yedekleme ve DDoS koruması.",
//       color: "#8b5cf6",
//       gradient: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
//       features: ["Şifreli Bağlantı", "İki Faktörlü Güvenlik", "DDoS Koruması", "Otomatik Yedekleme"]
//     },
//     {
//       icon: <SupportIcon sx={{ fontSize: 50 }} />,
//       title: "7/24 Türkçe Destek",
//       subtitle: "Sorun Olduğunda Yanınızdayız",
//       description: "Türkçe e-posta ve telefon desteği. Video eğitimler, kullanım kılavuzları ve kurulum desteği.",
//       color: "#f59e0b",
//       gradient: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
//       features: ["Türkçe Destek", "Video Eğitimler", "Kullanım Kılavuzu", "Kurulum Desteği"]
//     },
//     {
//       icon: <AnalyticsIcon sx={{ fontSize: 50 }} />,
//       title: "Gelişmiş Analitik",
//       subtitle: "Veriye Dayalı Kararlar",
//       description: "Hangi haberler popüler, okuyucular nereden geliyor? Tüm verileri grafiklerle görün ve stratejinizi belirleyin.",
//       color: "#ef4444",
//       gradient: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
//       features: ["Gerçek Zamanlı Veriler", "Isı Haritaları", "A/B Testleri", "Kullanıcı Yolculuğu"]
//     },
//     {
//       icon: <CloudIcon sx={{ fontSize: 50 }} />,
//       title: "Bulut Altyapı",
//       subtitle: "Her Yerden Erişim",
//       description: "Sunucu kurulumu, bakım ve güncelleme derdi yok. Trafik arttığında sistem otomatik büyür.",
//       color: "#06b6d4",
//       gradient: "linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)",
//       features: ["Otomatik Büyüme", "Yük Dengeleme", "%99.9 Çalışma Garantisi", "Global Hız"]
//     }
//   ];

//   // Intersection Observer
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             setIsInView(true);
//           }
//         });
//       },
//       { threshold: 0.2 }
//     );
//   }, []);

//  return (
//     <Box sx={{ backgroundColor:'#f1f6fb' }}>
//         <Box
//       sx={{
//         py: { xs: 10, md: 16 },
//         borderRadius: {xs : 0, md : '400px 0 400px 0'},
//         background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
//         position: 'relative',
//         overflow: 'hidden',
//         '&::before': {
//           content: '""',
//           position: 'absolute',
//           top: 0,
//           left: 0,
//           right: 0,
//           bottom: 0,
//           //backgroundImage: `url(${require('../assets/template-asset-1.png')})`,
//           backgroundSize: 'cover',
//           backgroundPosition: 'center',
//           backgroundRepeat: 'no-repeat',
//           opacity: 0.8,
//           filter: 'brightness(1.5) contrast(1.3)',
//           transform: 'scaleY(-1)',
//           pointerEvents: 'none',
//           zIndex: 1
//         }
//       }}
//     >
//       <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
//         {/* Header */}
//         <Box textAlign="center" mb={10}>
//         <Typography
//               variant="overline"
//               sx={{
//                 fontSize: '0.9rem',
//                 fontWeight: 900,
//                 letterSpacing: '0.1em',
//                 color: '#3b82f6',
//                 mb: 2,
//                 display: 'block',
//                 textTransform: 'uppercase'
//               }}
//             >
//              Altyapı
//             </Typography>

//           <Typography
//             variant="h2"
//             sx={{
//               fontSize: { xs: '2rem', md: '3rem' },
//               fontWeight: 800,
//               mb: 2,
//               color: 'white',
//               fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
//               lineHeight: 1.1
//             }}
//           >
//           Güçlü Teknoloji Altyapısı
//           </Typography>
          
//           <Typography
//             variant="h6"
//             sx={{
//               fontSize: { xs: '0.9rem', md: '1.1rem' },
//               color: 'rgba(255,255,255,0.9)',
//               maxWidth: 600,
//               mx: 'auto',
//               lineHeight: 1.4,
//               fontWeight: 400,
//               opacity: 0.9
//             }}
//           >
//             Güvenli, hızlı ve kolay kullanımlı profesyonel haber platformu. 
//             Teknik detaylarla uğraşmayın, haberciliğe odaklanın.
//           </Typography>
//         </Box>

//         {/* Features Grid */}
//         <Grid container spacing={4}>
//           {features.map((feature, index) => (
//             <Grid item xs={12} md={6} lg={4} key={index}>
//               <Card
//                 onMouseEnter={() => setHoveredCard(index)}
//                 onMouseLeave={() => setHoveredCard(null)}
//                 elevation={0}
//                 sx={{
//                   height: '100%',
//                   background: 'rgba(255, 255, 255, 0.05)',
//                   backdropFilter: 'blur(10px)',
//                   border: '1px solid rgba(255, 255, 255, 0.1)',
//                   borderRadius: 3,
//                   cursor: 'pointer',
//                   transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
//                   transform: hoveredCard === index ? 'translateY(-8px) scale(1.02)' : 'translateY(0)',
//                   boxShadow: hoveredCard === index
//                     ? `0 20px 40px ${feature.color}30`
//                     : 'none',
//                   position: 'relative',
//                   overflow: 'hidden',
//                   animation: `fadeInUp 0.6s ease-out ${index * 0.1}s both`,
//                   '&::before': {
//                     content: '""',
//                     position: 'absolute',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     height: 3,
//                     background: feature.gradient,
//                     opacity: hoveredCard === index ? 1 : 0,
//                     transition: 'opacity 0.3s ease'
//                   },
//                   '&:hover': {
//                     borderColor: `${feature.color}50`
//                   }
//                 }}
//               >
//                 <CardContent sx={{ p: 4, height: '100%', position: 'relative', zIndex: 1 }}>
//                   {/* Icon */}
//                   <Box
//                     sx={{
//                       display: 'inline-flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       width: 70,
//                       height: 70,
//                       borderRadius: 3,
//                       background: hoveredCard === index ? feature.gradient : `${feature.color}20`,
//                       color: hoveredCard === index ? '#fff' : feature.color,
//                       mb: 3,
//                       transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
//                       transform: hoveredCard === index ? 'scale(1.1) rotate(5deg)' : 'scale(1)',
//                       boxShadow: hoveredCard === index ? `0 10px 30px ${feature.color}40` : 'none'
//                     }}
//                   >
//                     {feature.icon}
//                   </Box>

//                   {/* Title & Subtitle */}
//                   <Typography
//                     variant="h6"
//                     sx={{
//                       fontWeight: 700,
//                       mb: 1,
//                       color: '#fff',
//                       fontSize: '1.25rem',
//                       fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif'
//                     }}
//                   >
//                     {feature.title}
//                   </Typography>
                  
//                   <Typography
//                     variant="body2"
//                     sx={{
//                       fontWeight: 600,
//                       mb: 2,
//                       fontSize: '0.95rem',
//                       background: feature.gradient,
//                       backgroundClip: 'text',
//                       WebkitBackgroundClip: 'text',
//                       WebkitTextFillColor: 'transparent'
//                     }}
//                   >
//                     {feature.subtitle}
//                   </Typography>

//                   {/* Description */}
//                   <Typography
//                     variant="body2"
//                     sx={{
//                       color: 'rgba(255,255,255,0.9)',
//                       lineHeight: 1.7,
//                       mb: 3,
//                       fontSize: '0.95rem'
//                     }}
//                   >
//                     {feature.description}
//                   </Typography>

//                   {/* Feature Tags */}
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       flexWrap: 'wrap',
//                       gap: 1
//                     }}
//                   >
//                     {feature.features.map((tag, tagIndex) => (
//                       <Chip
//                         key={tagIndex}
//                         label={tag}
//                         size="small"
//                         sx={{
//                           background: `${feature.color}20`,
//                           color: feature.color,
//                           fontSize: '0.7rem',
//                           height: '24px',
//                           fontWeight: 600,
//                           border: `1px solid ${feature.color}40`,
//                           transition: 'all 0.3s ease',
//                           '&:hover': {
//                             background: feature.gradient,
//                             color: '#fff',
//                             borderColor: 'transparent',
//                             transform: 'translateY(-2px)'
//                           }
//                         }}
//                       />
//                     ))}
//                   </Box>
//                 </CardContent>
//               </Card>
//             </Grid>
//           ))}
//         </Grid>
//       </Container>

//       {/* CSS Animations */}
//       <style jsx>{`
//         @keyframes fadeInUp {
//           from {
//             opacity: 0;
//             transform: translateY(30px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
        
//         @keyframes rotate {
//           from {
//             transform: rotate(0deg);
//           }
//           to {
//             transform: rotate(360deg);
//           }
//         }
//       `}</style>
//     </Box>
//     </Box>
//   )
// };

// export default ModernFeatures;


import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  Stack,
  alpha,
  Chip
} from '@mui/material';
import {
  Widgets as WidgetsIcon,
  Speed as SpeedIcon,
  Security as SecurityIcon,
  Analytics as AnalyticsIcon,
  Cloud as CloudIcon,
  Devices as DevicesIcon,
  CheckCircle as CheckIcon,
   AutoAwesome as AIIcon,
   TrendingUp,
} from '@mui/icons-material';

const ModernFeatures = () => {
  const [hoveredCard, setHoveredCard] = useState(null);
  const [isInView, setIsInView] = useState(false);
  const sectionRef = useRef(null);

  const features = [
    {
      icon: <AIIcon sx={{ fontSize: 50 }} />,
      title: "Yapay Zeka Destekli",
      subtitle: "Akıllı İçerik Asistanı",
      description: "Otomatik başlık önerileri, SEO iyileştirmeleri ve trend analizi. Yapay zeka hangi konuların popüler olduğunu söyler.",
      color: "#3b82f6",
      gradient: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
      features: ["Akıllı Başlık Önerileri", "SEO İyileştirme", "Trend Analizi", "Otomatik Etiketleme"]
    },
    {
      icon: <SpeedIcon sx={{ fontSize: 50 }} />,
      title: "Yüksek Performans",
      subtitle: "Okuyucular Beklemez",
      description: "1 saniyenin altında sayfa yükleme. Otomatik görsel optimizasyonu, CDN desteği ve temiz kod yapısı. Mobil öncelikli tasarım.",
      color: "#10b981",
      gradient: "linear-gradient(135deg, #10b981 0%, #047857 100%)",
      features: ["<1 Saniye Yükleme", "Otomatik Optimizasyon", "CDN Desteği", "Mobil Hızlı"]
    },
    {
      icon: <SecurityIcon sx={{ fontSize: 50 }} />,
      title: "Kurumsal Güvenlik",
      subtitle: "Verileriniz Güvende",
      description: "Banka seviyesinde güvenlik standartları. SSL şifreleme, iki faktörlü kimlik doğrulama, otomatik yedekleme ve DDoS koruması.",
      color: "#8b5cf6",
      gradient: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
      features: ["SSL Şifreleme", "İki Faktörlü Güvenlik", "DDoS Koruması", "Otomatik Yedekleme"]
    },
    {
      icon: <TrendingUp />,
      title: "SEO Optimizasyonu",
      subtitle: "Google'da Üst Sıralarda",
      color: "#f59e0b",
      gradient: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
      description: "Otomatik sitemap, meta tag yönetimi ve yapısal veri desteği. Arama motorlarında üst sıralarda yer alın.",
      features: ["Otomatik Sitemap", "Meta Tag", "Schema.org", "Hızlı İndeksleme"]
    },
    {
      icon: <AnalyticsIcon sx={{ fontSize: 50 }} />,
      title: "Detaylı Analitik",
      subtitle: "Veriye Dayalı Kararlar",
      description: "Hangi haberler popüler, okuyucular nereden geliyor? Tüm verileri grafiklerle görün ve stratejinizi belirleyin. Gerçek zamanlı raporlar.",
      color: "#ef4444",
      gradient: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
      features: ["Gerçek Zamanlı", "Isı Haritaları", "Trafik Kaynakları", "İçerik Analizi"]
    },
    {
      icon: <CloudIcon sx={{ fontSize: 50 }} />,
      title: "Bulut Altyapı",
      subtitle: "Otomatik Ölçeklendirme",
      description: "Sunucu kurulumu, bakım ve güncelleme derdi yok. Trafik arttığında sistem otomatik büyür. %99.9 çalışma garantisi.",
      color: "#06b6d4",
      gradient: "linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)",
      features: ["Otomatik Büyüme", "Yük Dengeleme", "%99.9 Uptime", "Global CDN"]
    }
  ];

  // Intersection Observer
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsInView(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    const currentRef = sectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <Box sx={{ backgroundColor: '#f1f6fb' }}>
      <Box
        ref={sectionRef}
        sx={{
          py: { xs: 10, md: 16 },
          borderRadius: { xs: 0, md: '400px 0 400px 0' },
          background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            opacity: 0.8,
            filter: 'brightness(1.5) contrast(1.3)',
            transform: 'scaleY(-1)',
            pointerEvents: 'none',
            zIndex: 1
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: `
              radial-gradient(circle at 30% 30%, rgba(59, 130, 246, 0.15) 0%, transparent 60%),
              radial-gradient(circle at 70% 70%, rgba(16, 185, 129, 0.1) 0%, transparent 60%)
            `,
            pointerEvents: 'none',
            zIndex: 1
          }
        }}
      >
        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
          {/* Header */}
          <Box textAlign="center" mb={10}>
            <Chip
              label="ALTYAPI"
              sx={{
                fontSize: '0.85rem',
                fontWeight: 900,
                letterSpacing: '0.1em',
                background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
                color: 'white',
                mb: 3,
                px: 2,
                py: 2.5,
                animation: isInView ? 'fadeInUp 0.6s ease-out' : 'none'
              }}
            />

            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                fontWeight: 800,
                mb: 3,
                color: 'white',
                fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
                lineHeight: 1.1,
                animation: isInView ? 'fadeInUp 0.8s ease-out 0.2s both' : 'none'
              }}
            >
              Güçlü Teknoloji Altyapısı
            </Typography>
            
            <Typography
              variant="h6"
              sx={{
                fontSize: { xs: '1.1rem', md: '1.3rem' },
                color: 'rgba(255,255,255,0.85)',
                maxWidth: 700,
                mx: 'auto',
                lineHeight: 1.6,
                fontWeight: 400,
                animation: isInView ? 'fadeInUp 1s ease-out 0.4s both' : 'none'
              }}
            >
              Güvenli, hızlı ve kolay kullanımlı profesyonel haber platformu. 
              Teknik detaylarla uğraşmayın, haberciliğe odaklanın.
            </Typography>
          </Box>

          {/* Features Grid */}
          <Grid container spacing={4}>
            {features.map((feature, index) => (
              <Grid item xs={12} md={6} lg={4} key={index}>
                <Card
                  onMouseEnter={() => setHoveredCard(index)}
                  onMouseLeave={() => setHoveredCard(null)}
                  elevation={0}
                  sx={{
                    height: '100%',
                    minHeight: '380px',
                    background: 'rgba(255, 255, 255, 0.05)',
                    backdropFilter: 'blur(20px)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    borderRadius: 4,
                    cursor: 'pointer',
                    transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                    transform: hoveredCard === index ? 'translateY(-12px) scale(1.02)' : 'translateY(0)',
                    boxShadow: hoveredCard === index
                      ? `0 25px 50px ${feature.color}30, 0 10px 20px rgba(0, 0, 0, 0.2)`
                      : '0 4px 12px rgba(0, 0, 0, 0.1)',
                    position: 'relative',
                    overflow: 'hidden',
                    animation: isInView ? `fadeInUp 0.6s ease-out ${index * 0.15}s both` : 'none',
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      height: 4,
                      background: feature.gradient,
                      opacity: hoveredCard === index ? 1 : 0,
                      transition: 'opacity 0.3s ease'
                    },
                    '&::after': {
                      content: '""',
                      position: 'absolute',
                      top: -50,
                      right: -50,
                      width: 100,
                      height: 100,
                      background: `radial-gradient(circle, ${feature.color}20 0%, transparent 70%)`,
                      opacity: hoveredCard === index ? 1 : 0,
                      transition: 'opacity 0.4s ease'
                    },
                    '&:hover': {
                      borderColor: `${feature.color}50`
                    }
                  }}
                >
                  <CardContent sx={{ p: 4, height: '100%', position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column' }}>
                    {/* Icon */}
                    <Box
                      sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 80,
                        height: 80,
                        borderRadius: 3,
                        background: hoveredCard === index ? feature.gradient : `${feature.color}20`,
                        color: hoveredCard === index ? '#fff' : feature.color,
                        mb: 3,
                        transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                        transform: hoveredCard === index ? 'scale(1.15) rotate(5deg)' : 'scale(1)',
                        boxShadow: hoveredCard === index ? `0 12px 35px ${feature.color}50` : 'none'
                      }}
                    >
                      {feature.icon}
                    </Box>

                    {/* Title & Subtitle */}
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        mb: 1,
                        color: '#fff',
                        fontSize: '1.35rem',
                        fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif'
                      }}
                    >
                      {feature.title}
                    </Typography>
                    
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 600,
                        mb: 2.5,
                        fontSize: '1rem',
                        background: feature.gradient,
                        backgroundClip: 'text',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent'
                      }}
                    >
                      {feature.subtitle}
                    </Typography>

                    {/* Description */}
                    <Typography
                      variant="body2"
                      sx={{
                        color: 'rgba(255,255,255,0.85)',
                        lineHeight: 1.7,
                        mb: 3,
                        fontSize: '0.95rem',
                        flex: 1
                      }}
                    >
                      {feature.description}
                    </Typography>

                    {/* Feature Tags */}
                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1
                      }}
                    >
                      {feature.features.map((tag, tagIndex) => (
                        <Chip
                          key={tagIndex}
                          label={tag}
                          size="small"
                          sx={{
                            background: `${feature.color}25`,
                            color: hoveredCard === index ? 'white' : feature.color,
                            fontSize: '0.75rem',
                            height: '26px',
                            fontWeight: 600,
                            border: `1px solid ${feature.color}40`,
                            transition: 'all 0.3s ease',
                            '&:hover': {
                              background: feature.gradient,
                              color: '#fff',
                              borderColor: 'transparent',
                              transform: 'translateY(-2px)'
                            }
                          }}
                        />
                      ))}
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>

        {/* CSS Animations */}
        <style jsx>{`
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}</style>
      </Box>
    </Box>
  );
};

export default ModernFeatures;